module.exports = __webpack_public_path__ + "static/media/event-can.4a10fff7.svg";